import PropTypes from "prop-types";
import React from "react";
import { connect } from "react-redux";

import {
  addPriorityMessage,
  confirmationRequest,
  disablePriorityMessage,
  setPageTitle,
  updateContentFeed,
  updateDevice,
  updateDeviceUngroupedWrapers,
  updatePriorityMessage,
  addUserReport,
} from "../../../../actions";
import { searchStrFromRouterLocation } from "signoxe/utils/router";

import { DEVICE_GROUPS_RESOURCE } from "../../../../api/resources";
import DeviceUngroupedList from "../../../../components/DeviceUngroupedList";
import Page from "../../../../components/layout/Page";
import {
  getFilteredDevicesWrapers,
  getFilteredDevices,
  getFeatureStatus,
  getCurrentDeviceId,
} from "../../../../selectors";
import { getProfile } from "../../../../selectors/profile";
import { searchDevices } from "signoxe/actions";

import {
  ContentModal,
  EmptyMessage,
} from "../../../../components/widgets";


// THIS PAGE CONTAINS DEVICES WHICH HAVE BEEN ASSIGNED TO A GROUPED, 
class UngroupedDevices extends React.Component {
  static propTypes = {
    addUserReport: PropTypes.func.isRequired,
    groups: PropTypes.array.isRequired,
    dropdownGroups: PropTypes.array.isRequired,
    searchDevices: PropTypes.func.isRequired,
    screenshotsEnabled: PropTypes.bool,
    smartBoardEnabled: PropTypes.bool,
    updateDeviceUngroupedWrapers: PropTypes.func.isRequired,
    updateDevice: PropTypes.func.isRequired,
    confirmationRequest: PropTypes.func.isRequired,
    updateContentFeed: PropTypes.func.isRequired,
    setPageTitle: PropTypes.func.isRequired,
    addPriorityMessage: PropTypes.func.isRequired,
    updatePriorityMessage: PropTypes.func.isRequired,
    disablePriorityMessage: PropTypes.func.isRequired,
    history: PropTypes.object.isRequired,
    searchString: PropTypes.string,
    isFetching: PropTypes.bool.isRequired,
    deviceTags: PropTypes.object,

    profile: PropTypes.shape({
      username: PropTypes.string.isRequired,
      email: PropTypes.string.isRequired,
      activation_date: PropTypes.string.isRequired,
      renewal_date: PropTypes.string.isRequired,
      next_renewal_date: PropTypes.string.isRequired,
      profile: PropTypes.shape({
        name: PropTypes.string.isRequired,
        organisation_name: PropTypes.string.isRequired,
        organisation_address: PropTypes.string.isRequired,
        primary_contact_name: PropTypes.string.isRequired,
        primary_contact_phone: PropTypes.string.isRequired,
        primary_contact_email: PropTypes.string.isRequired,
        financial_contact_name: PropTypes.string.isRequired,
        financial_contact_email: PropTypes.string.isRequired,
        financial_contact_phone: PropTypes.string.isRequired,
        technical_contact_name: PropTypes.string.isRequired,
        technical_contact_email: PropTypes.string.isRequired,
        technical_contact_phone: PropTypes.string.isRequired,
      }).isRequired,
    }),
  };

  constructor(props) {
    super(props);
    this.state = props.profile ? props.profile.profile : null;
    this.state = {
      showMobileBox: true,
      showView: true,
    };
  }


handleUserReport = (message) => {
    const {profile} = this.props;
    if (profile && profile.features && profile.features.record_user_activity){
      this.props.addUserReport({
        user: profile.id,
        action_type: "Update",
        activity:message 
      });
    }
  }


  onToggleBackMobile = (value) => this.setState({ showMobileBox: value });

  onToggleBack = (value) => this.setState({ showView: value });

  handleClickSchedule = (deviceGroup) =>
    this.props.history.push(`/device-groups/${deviceGroup.id}/schedule`);

  handleDeviceGroupChange = (id, newGroup) => {
    this.props.updateDeviceUngroupedWrapers(id, newGroup);
  }

  handleDeviceGroupDelete = (deviceGroup) =>
    this.props.confirmationRequest(
      "Unasign Device",
      `Unasining device will remove all current resourses allocated to this device, 
      unasinged device will be moved to Unasinged Devices page section`,
      "DELETE",
      DEVICE_GROUPS_RESOURCE,
      deviceGroup.id
    );

  handleGroupFeedChange = (id, newFeed) =>
    this.props.updateContentFeed(id, newFeed);

  handlePriorityMessageActivate = (groupId) =>
    this.props.addPriorityMessage({ id: groupId });

  handlePriorityMessageChange = (groupId, msg) =>
    this.props.updatePriorityMessage(groupId, msg);

  handlePriorityMessageDeactivate = (groupId) =>
    this.props.disablePriorityMessage(groupId);

  onDeviceChange = (newDevice) =>
    this.props.updateDevice(newDevice.id, newDevice);

  componentDidMount() {
    this.props.searchDevices(""); // Clear any existing search query
    this.props.setPageTitle('Grouped Devices');
  }

  showText(text) {
    return <span className="show-text">{text}</span>;
  }

  render() {
    const { showMobileBox, showMobileBox, showView } = this.state;
    
    return (
      <Page key={new Date().getTime()}>

       {!this.props.isFetching && this.props.groups.length === 0 ? 
       <EmptyMessage text="No Device yet. Please Add one"/>
       :
        <DeviceUngroupedList
          handleUserReport={this.handleUserReport}
          deviceGroups={this.props.groups}
          dropdownGroups={this.props.dropdownGroups}
          screenshotsEnabled={this.props.screenshotsEnabled}
          smartBoardEnabled={this.props.smartBoardEnabled}
          deviceReportEnabled={this.props.deviceReportingEnabled}
          rebootEnabled={this.props.rebootEnabled}
          RestartAppEnabled={this.props.RestartAppEnabled}
          ClearUnusedMediaEnabled={this.props.ClearUnusedMediaEnabled}
          offlineEnabled={this.props.offlineEnabled}
          delayDownloadEnabled={this.props.delayDownloadEnabled}
          onDeviceChange={this.onDeviceChange}
          onDeviceGroupDelete={this.handleDeviceGroupDelete}
          onDeviceGroupChange={this.handleDeviceGroupChange}
          onGroupFeedChange={this.handleGroupFeedChange}
          onClickSchedule={this.handleClickSchedule}
          onPriorityMessageActivate={this.handlePriorityMessageActivate}
          onPriorityMessageChange={this.handlePriorityMessageChange}
          onPriorityMessageDeactivate={this.handlePriorityMessageDeactivate}
          queryString={this.props.searchString}
          deviceTags={this.props.deviceTags}
          />}
        <ContentModal 
          handleUserReport={this.handleUserReport}
          onDeviceGroupChange={this.handleDeviceGroupChange}
          deviceTags={this.props.deviceTags}
          id={this.props.currentDeviceId} visible={false} />
      </Page>
    );
  }
}

export default connect(
  (state, props) => {
    const searchString = searchStrFromRouterLocation(props.history.location); 
    const deviceTags = props.deviceTags;
    console.log(state)
    return {
      searchString,

      groups: getFilteredDevicesWrapers(state, searchString, deviceTags),
      dropdownGroups: getFilteredDevices(state, ''),

      profile: getProfile(state),
      screenshotsEnabled: getFeatureStatus(state, "screenshots"),
      smartBoardEnabled: getFeatureStatus(state, "smart_notice_board"),
      deviceReportingEnabled: getFeatureStatus(state, "device_reporting"),
      rebootEnabled: getFeatureStatus(state, "reboot_device"),
      RestartAppEnabled: getFeatureStatus(state, "restart_app_enabled"),
      ClearUnusedMediaEnabled: getFeatureStatus(state, "clear_unused_media_enabled"),
      offlineEnabled: getFeatureStatus(state, "offline_device"),
      delayDownloadEnabled: getFeatureStatus(state, "delayed_download"),
      currentDeviceId: getCurrentDeviceId(state),
      isFetching: state.deviceGroups.isFetching,
      
    };
  },
  {
    updateDeviceUngroupedWrapers,
    updateDevice,
    updateContentFeed,
    confirmationRequest,
    setPageTitle,
    addPriorityMessage,
    updatePriorityMessage,
    disablePriorityMessage,
    searchDevices,
    addUserReport,
  }
)(UngroupedDevices);



// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./src/containers/DevicesPage/tabs/UngroupedDevices/ungroupedDevices.js